<template>
  <div>
    <div class="searchArea">
      <div class="sortSave">
        <input type="checkbox" id="saveCheck" v-model="onlySavedRaces" @change="toggleSavedRaces" />
        <label for="saveCheck">★<span>나의 대회</span></label>
        
      </div>
      <div class="time-inputs-div">
        <select v-model="selectedRegion">
          <option value="">지역</option>
          <option v-for="region in regions" :key="region" :value="region">{{ region }}</option>
        </select>
      </div>
      <div class="time-inputs-div">
        <select v-model="selectedRatingSort">
          <option value="">평점</option>
          <option value="5">5.0점대</option>
          <option value="4">4.0점대</option>
          <option value="3">3.0점대</option>
          <option value="2">2.0점대</option>
          <option value="1">1.0점대</option>
        </select>
      </div>
      <button class="reset-button" @click="resetFilters">
        <svg
          id="Layer_1"
          width="18"
          height="18"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 118.04 122.88"
        >
          <path
            style="fill: rgb(255, 255, 255)"
            d="M16.08,59.26A8,8,0,0,1,0,59.26a59,59,0,0,1,97.13-45V8a8,8,0,1,1,16.08,0V33.35a8,8,0,0,1-8,8L80.82,43.62a8,8,0,1,1-1.44-15.95l8-.73A43,43,0,0,0,16.08,59.26Zm22.77,19.6a8,8,0,0,1,1.44,16l-10.08.91A42.95,42.95,0,0,0,102,63.86a8,8,0,0,1,16.08,0A59,59,0,0,1,22.3,110v4.18a8,8,0,0,1-16.08,0V89.14h0a8,8,0,0,1,7.29-8l25.31-2.3Z"
          />
        </svg>
      </button>
    </div>

    <button v-if="showRegisterButton" class="btnRace" @click="openRegisterModal">대회 등록</button>

    <div class="raceList">
      <!-- 조건에 해당하는 대회가 없을 때 메시지 출력 -->
      <div v-if="filteredRaceData.length === 0" class="no-results">
        조건에 해당하는 대회가 없습니다.
      </div>
      <div
        class="raceList__inner"
        v-for="(month, index) in filteredRaceData"
        :key="index"
      >
        <strong class="tit">{{ month.name }}</strong>
        <ul>
          <li v-for="race in month.races" :key="race.id">
            <input
              type="checkbox"
              :id="'race-' + race.id"
              :value="race.id"
              v-model="selectedRaces"
              @change="saveToLocalStorage"
            />
            <label :for="'race-' + race.id">★</label>
            <a :href="race.url" class="raceList__info" target="_blank">
              <div>
                <strong>{{ race.name }}</strong>
                <ul>
                  <li>{{ race.distances }}</li>
                  <li>{{ race.location }}</li>
                  <li class="hidden">{{ race.day }}</li>
                </ul>
              </div>
            </a>
            <a href="javascript:void(0)" class="raceList__score" @click="openModal(race)">
              <span>{{ race.averageRating }}<i><strong>{{ race.ratingCount }}</strong>명 참여</i></span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- 팝업 모달 추가 -->
    <div v-if="showRatingModal" class="modal-overlay">
      <div class="modal">
        <h3>평점 입력</h3>
        <div class="modal__select">
          <div class="stars">
            <span
              v-for="star in 5"
              :key="star"
              class="star"
              :class="{ active: selectedRating >= star }"
              @click="setRating(star)"
            >
              ★
            </span>
          </div>
        </div>
        <div class="modal__btns">
          <button @click="submitRating">제출</button>
          <button @click="closeModal">취소</button>
        </div>
      </div>
    </div>

    <!-- 대회 등록 모달 -->
    <div v-if="showRegisterModal" class="modal-overlay">
      <div class="modal">
        <h3>대회 등록</h3>
        <div class="modal__form">
          <div class="modal__form-row">
            <label for="race-name">대회 이름</label>
            <input type="text" id="race-name" v-model="newRace.name" placeholder="대회 이름" />
          </div>

          <div class="modal__form-row">
            <label for="race-location">대회 위치</label>
            <select id="race-location" v-model="newRace.location">
              <option value="">지역 선택</option>
              <option v-for="region in regions" :key="region" :value="region">{{ region }}</option>
            </select>
          </div>

          <div class="modal__form-row">
            <label for="race-distances">대회 거리 (쉼표로 구분)</label>
            <input type="text" id="race-distances" v-model="newRace.distances" placeholder="예: 풀,하프,10km" />
          </div>

          <div class="modal__form-row">
            <label for="race-month">대회 월</label>
            <input type="text" id="race-month" v-model="newRace.month" placeholder="예: 1월" />
          </div>
          <div class="modal__form-row">
            <label for="race-month">대회 날짜</label>
            <input type="text" id="race-day" v-model="newRace.day" placeholder="예: 14" />
          </div>

          <div class="modal__form-row">
            <label for="race-url">대회 URL</label>
            <input type="url" id="race-url" v-model="newRace.url" placeholder="대회 공식 사이트 URL" />
          </div>
        </div>

        <div class="modal__btns">
          <button @click="submitRaceRegistration">등록</button>
          <button @click="closeRegisterModal">취소</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { initializeApp } from "firebase/app";
import { getDatabase, ref, get, set } from "firebase/database";

export default {
  name: "RaceViews",
  data() {
    return {
      raceData: [],
      showRatingModal: false,
      selectedRace: null,
      db: null,
      selectedRating: '',
      selectedRatingSort: '',
      selectedRegion: '',
      showRegisterButton: false,
      showRegisterModal: false,
      newRace: {
        name: '',
        location: '',
        distances: '',
        month: '',
        day: '',
        url: '',
      },
      regions: ['서울', '경기', '강원', '충북', '충남', '전북', '전남', '경북', '경남', '제주', '부산', '대구', '인천', '광주', '울산', '대전', '세종', '온라인'],
      selectedRaces: [], // 체크된 대회 목록
      onlySavedRaces: false, // 저장된 대회만 보기 여부
    };
  },
  mounted() {
    const firebaseConfig = {
      apiKey: "AIzaSyBRTJR6NnDOOT_5px-iGt2YXUW2sFXZBDo",
      authDomain: "calcul-f8059.firebaseapp.com",
      databaseURL: "https://calcul-f8059-default-rtdb.firebaseio.com",
      projectId: "calcul-f8059",
      storageBucket: "calcul-f8059.firebasestorage.app",
      messagingSenderId: "332262457868",
      appId: "1:332262457868:web:e80b18bde1a1d7f0f3a429",
      measurementId: "G-ZFXXD1Q4RX",
    };

    const app = initializeApp(firebaseConfig);
    this.db = getDatabase(app);
    this.loadRaceData();
    this.getUserIP().then((ip) => {
      if (ip === '121.128.125.13' || ip === '211.36.142.93') {
        this.showRegisterButton = true;
      } else {
        this.showRegisterButton = false;
      }
    });
    this.loadFromLocalStorage();
  },
  computed: {
    filteredRaceData() {
      let filteredData = this.raceData
        .filter(month => month.races.length > 0) // 빈 races 필터링
        .map(month => {
          return {
            ...month,
            races: month.races.filter(race => {
              const matchesRegion = this.selectedRegion === "" || race.location === this.selectedRegion;
              const matchesRating =
                this.selectedRatingSort === "" ||
                Math.floor(parseFloat(race.averageRating)) === parseInt(this.selectedRatingSort);
              const matchesSaved = !this.onlySavedRaces || this.selectedRaces.includes(race.id); // 저장된 레이스만 필터

              return matchesRegion && matchesRating && matchesSaved;
            }),
          };
        })
        .filter(month => month.races.length > 0); // 비어있는 races 제거

      // 저장된 대회만 보기를 활성화했을 때, 아무 대회도 남지 않으면 alert 표시
      // if (this.onlySavedRaces && filteredData.length === 0) {
      //   alert("저장된 대회가 없습니다");
      // }

      return filteredData;
    }
  },
  methods: {
    getUserIP() {
      return fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => data.ip)
        .catch(error => {
          console.error('Error fetching IP:', error);
          return '';
        });
    },
    saveToLocalStorage() {
      localStorage.setItem("selectedRaces", JSON.stringify(this.selectedRaces));
    },
    loadFromLocalStorage() {
      const savedRaces = localStorage.getItem("selectedRaces");
      if (savedRaces) {
        this.selectedRaces = JSON.parse(savedRaces);
      }
    },
    toggleSavedRaces() {
      // if (this.onlySavedRaces && this.selectedRaces.length === 0) {
      //   alert("저장된 대회가 없습니다");
      // }
    },
    openModal(race) {
      this.selectedRace = race;
      this.showRatingModal = true;
    },
    closeModal() {
      this.showRatingModal = false;
      this.selectedRating = '';
    },
    setRating(rating) {
      this.selectedRating = rating;
    },
    submitRating() {
      if (this.selectedRating < 1 || this.selectedRating > 5) {
        alert("1부터 5까지의 평점을 입력해주세요.");
        return;
      }

      this.getUserIP().then((ip) => {
        const raceId = this.selectedRace.id;
        this.checkDuplicateRating(raceId, ip).then((isDuplicate) => {
          if (isDuplicate) {
            alert("이미 이 대회에 평점을 등록하셨습니다.");
          } else {
            this.saveRating(raceId, this.selectedRating, ip);
          }
        });
      });
    },
    updateRaceRatingAndCount(raceId) {
      const ratingsRef = ref(this.db, `ratings/${raceId}`);
      get(ratingsRef).then((snapshot) => {
        const ratings = snapshot.val();
        if (ratings) {
          const total = Object.values(ratings).reduce((acc, curr) => acc + parseFloat(curr.rating), 0);
          const count = Object.values(ratings).length;
          const average = count > 0 ? (total / count).toFixed(1) : '없음';
          this.updateRaceData(raceId, { averageRating: average, ratingCount: count });
        } else {
          this.updateRaceData(raceId, { averageRating: '없음', ratingCount: 0 });
        }
      });
    },
    updateRaceData(raceId, updates) {
      if (Array.isArray(this.raceData)) {
        this.raceData = this.raceData.map(month => ({
          ...month,
          races: month.races.map(race => race.id === raceId ? { ...race, ...updates } : race)
        }));
      } else {
        console.error("raceData가 배열이 아닙니다:", this.raceData);
      }
    },
    checkDuplicateRating(raceId, ip) {
      const ratingsRef = ref(this.db, `ratings/${raceId}`);
      return get(ratingsRef).then((snapshot) => {
        const ratings = snapshot.val() || {};
        return Object.values(ratings).some(ratingData => ratingData.ip === ip);
      });
    },
    saveRating(raceId, rating, ip) {
      const ratingsRef = ref(this.db, `ratings/${raceId}`);
      if (isNaN(rating)) {
        alert("평점 값이 유효하지 않습니다. 다시 시도해주세요.");
        return;
      }

      get(ratingsRef)
        .then((snapshot) => {
          const ratings = snapshot.val() || {};
          const userId = this.getUserId();
          ratings[userId] = { rating, ip };

          set(ratingsRef, ratings)
            .then(() => {
              this.updateRaceRatingAndCount(raceId);
              this.closeModal();
            })
            .catch((error) => {
              console.error("Error saving rating:", error);
            });
        })
        .catch((error) => {
          console.error("Error getting ratings:", error);
        });
    },
    getUserId() {
      return `user_${Math.random().toString(36).substr(2, 9)}`;
    },
    openRegisterModal() {
      this.showRegisterModal = true;
    },
    closeRegisterModal() {
      this.showRegisterModal = false;
      this.resetNewRaceForm();
    },
    resetNewRaceForm() {
      this.newRace = {
        name: '',
        location: '',
        distances: '',
        month: '',
        day: '',
        url: '',
      };
    },
    submitRaceRegistration() {
      if (!this.newRace.name || !this.newRace.location || !this.newRace.distances || !this.newRace.month || !this.newRace.url || !this.newRace.day) {
        alert("모든 필드를 입력해주세요.");
        return;
      }

      const newRaceId = new Date().getTime().toString();
      set(ref(this.db, "races/" + newRaceId), {
        name: this.newRace.name,
        location: this.newRace.location,
        distances: this.newRace.distances,
        month: this.newRace.month,
        day: this.newRace.day,
        url: this.newRace.url,
      })
        .then(() => {
          alert("대회가 등록되었습니다.");
          this.closeRegisterModal();
          this.loadRaceData();
        })
        .catch((error) => {
          console.error("대회 등록 중 오류가 발생했습니다:", error);
        });
    },
    loadRaceData() {
      const racesRef = ref(this.db, "races");
      get(racesRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const data = snapshot.val();
            const organizedData = {};
            Object.keys(data).forEach((key) => {
              const race = data[key];
              const month = race.month;
              if (!organizedData[month]) {
                organizedData[month] = { name: month, races: [] };
              }
              organizedData[month].races.push({
                id: key,
                name: race.name,
                distances: race.distances,
                location: race.location,
                day: parseInt(race.day, 10),
                url: race.url,
              });
            });

            // 월 정렬을 위한 배열
            const monthOrder = [
              "1월", "2월", "3월", "4월", "5월", "6월", 
              "7월", "8월", "9월", "10월", "11월", "12월"
            ];

            this.raceData = Object.values(organizedData)
              .map((month) => ({
                ...month,
                races: month.races.sort((a, b) => a.day - b.day), // 날짜 순 정렬
              }))
              .sort((a, b) => monthOrder.indexOf(a.name) - monthOrder.indexOf(b.name)); // 월 순서 정렬

            // 각 대회의 평점 업데이트
            this.raceData.forEach((month) => {
              month.races.forEach((race) => {
                this.updateRaceRatingAndCount(race.id);
              });
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    
    resetFilters() {
      this.selectedRegion = "";
      this.selectedRatingSort = "";
    },
  },
};
</script>



<style scoped>
/* .raceList {
} */
.raceList .tit {
  font-size: 20px;
  margin: 30px 0 10px 0;
  display: block;
}
.raceList__inner > ul + .tit {
  margin-top: 30px;
}
.raceList__inner > ul {
  margin: 0 -1em;
  border: 1px solid #f0ddff;
  border-width: 1px 0;
}
.raceList__inner > ul > li {
  display: flex;
  align-items: center;
  padding-left:1em;
}
.raceList__inner > ul > li + li {
  border-top: 1px solid #f0ddff;
}
.raceList__inner > ul > li > a {
  display: block;
  text-decoration: none;
  color: inherit;
  padding: 5px 0;
}
.raceList__inner > ul > li > input[type="checkbox"]{
  overflow: hidden;
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
  z-index: -1;
}
.raceList__inner > ul > li > input[type="checkbox"] + label{
  display: block;
  width: 30px;
  height: 30px;
  display:flex;
  justify-content: center;
  align-items: center;
  color:#fff;
  color: #d1b9df;
  font-size: 20px;
  font-weight: bold;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
.raceList__inner > ul > li > input[type="checkbox"]:checked + label{
  color: #f4b400;
}

.raceList__info {
  flex: 1;
  padding-left: .2em !important;
}
.raceList__info strong {
  font-size: 15px;
  font-weight: bold;
  color: #510d85;
}
.raceList__info ul {
  margin-top: 3px;
}
.raceList__info ul > li {
  font-size: 11px;
  color: #ad8fc3;
  display: inline-block;
}
.raceList__info ul > li + li:before {
  content: "";
  display: inline-block;
  width: 1px;
  height: 10px;
  background: #e1e1e1;
  vertical-align: middle;
  margin: -2px 10px 0;
}
.raceList__score {
  padding-right: 1em !important;
}
.raceList__score > span {
  display: flex;
  height: 44px;
  width: 50px;
  background: #f3e4ff;
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  flex-direction: column;
  color: #9563bb;
}
.raceList__score > span > i {
  font-size: 8px;
  display: block;
  font-style: normal;
  margin-top: 3px;
  color: #ad8fc3;
}
.raceList__score > span > i > strong{
  font-weight: bold;
  color: #976db5;
}
.hidden {
  overflow: hidden;
  width: 0px;
  height: 0px;
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.searchArea {
  background: #9563bb;
  padding: 15px;
  display: flex;
  gap: 10px;
  border-radius: 15px;
  align-items: center;
}
.reset-button {
  position: static;
  width: 37px;
}
.time-inputs-div select {
  text-align: left;
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.modal {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 300px;
  text-align: center;
}
.modal > h3{
  padding-bottom: 15px;
  border-bottom: 1px solid #e1e1e1;
  text-align: left;
  font-weight: bold;
}
.modal__select{
  padding: 20px 0 30px;

}
.modal__select > select{
  width: 100%;
  height: 40px;
}
.modal__btns{
  display: flex;
  gap: 5px;
  
}
.modal__btns > button{
  flex:1;
  border: 0;
  border-radius: 5px;
  height: 35px;
  background: #e1e1e1;
  
  font-size: 15px;
}
.modal__btns > button:first-child{
  background: #5a2f7b;
  color:#fff;
}
/* 별 스타일링 */
.modal__select .stars {
  display: flex;
  justify-content: center;
  gap: 5px;
}

.modal__select .star {
  font-size: 30px;
  cursor: pointer;
  color: #ccc;
}

.modal__select .star.active {
  color: #f4b400;
}

.modal__select .star:hover {
  color: #f4b400;
}
.btnRace{height: 30px; margin-top: 20px;}

.modal__form{
  padding: 20px 0;
}
.modal__form-row{
  display: flex;
}
.modal__form-row + .modal__form-row{
  margin-top: 10px;
}
.modal__form-row > label{
  width: 80px;
  text-align: left;
}
.modal__form-row > input,
.modal__form-row > select{
  flex: 1;
}
.no-results {
  text-align: center;
  color: #ababab;
  font-size: 16px;
  margin: 50px 0 0;
}
.sortSave{
  margin-right: 10px;
  text-align: center;
}
.sortSave input[type="checkbox"]{
  overflow: hidden;
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
}
.sortSave input[type="checkbox"] + label{
  font-size: 24px;
  color: #dfb4ff;
}
.sortSave input[type="checkbox"]:checked + label{
  color: #f4b400;
}
.sortSave input[type="checkbox"] + label > span{
  font-size: 10px;
  display: block;
  margin-top: 3px;
  color: #dfb4ff;
  opacity: .7;
}

</style>